module.exports = __webpack_public_path__ + "static/media/iconatpl.9919ec1d.svg";